import features from './features.yml'
import projects from './projects.yml'
import facilities from './facilities.yml'

export default {
  features,
  projects,
  facilities,
}


// WEBPACK FOOTER //
// ./src/data/about/index.js